import React from 'react';
import { useTranslation } from 'react-i18next';
import PieChart from '../../charts/PieChart'
import { useGetDashboardDeviceByOsQuery } from '../../../api/dashboardApiSlice';
import BlockChartLoader from '../../BlockChartLoader';

export default function DeviceByOs ({filter}) {
	const { t } = useTranslation();
  const { data = [], isSuccess, isLoading, isError, refetch } = useGetDashboardDeviceByOsQuery({filter})
  const chartData = data.map((x)=>({"name":x.os,"y":x.active_devices}));

  return (
    <BlockChartLoader title={t("publisher.deviceByOs")} success={(!isLoading && isSuccess)} error={(!isLoading && isError)} retry={refetch}>
      <PieChart data={chartData}/>
    </BlockChartLoader>
  )
}
